import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Box, TextField } from "@material-ui/core";
import SrLabel from "../SrLabel";

const StyledTextField = withStyles((theme) => ({
  root: {
    // Removes browser arrows on input type number
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    // Removes browser autofill color on inputs
    "& input:-webkit-autofill, &input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active":
      {
        "-webkit-box-shadow": "0 0 0 30px white inset !important",
      },
  },
}))(TextField);

const SrInput = ({ label, error, name, ...props }) => (
  <>
    {label && <SrLabel name={name}>{label}</SrLabel>}
    <Box mt={label ? 1 : ""}>
      <StyledTextField
        variant="outlined"
        error={error}
        id={name}
        name={name}
        {...props}
      />
    </Box>
  </>
);

SrInput.propTypes = {
  label: PropTypes.node,
  error: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

SrInput.defaultProps = {
  label: undefined,
  error: undefined,
};

export default SrInput;
